import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-add-individual',
  templateUrl: './add-individual.component.html',
  styleUrls: ['./add-individual.component.css'],
  standalone: false
})
export class AddIndividualComponent implements OnInit {
modalWidth: any;
form = new FormGroup({});
model: {
    dynamicIndData?: any[];
  }  = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];

  isCountryOriginData: boolean = false;
  ResidentialCountryID: any;
  residentialZip: any;
  indMailingZip: any;
  selectedMailingCountryID: any;
  selectedResidentialCountryID: any;

  constructor(
     @Optional() public dialogRef: MatDialogRef<any>, 
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any, 
        private spinner: NgxSpinnerService
        , private _api: ApiService
        , private dialog: MatDialog
  ) { }

findFieldByTypeAndLabel(fields: any[], type: string, label: string): any {
  for (const field of fields) {
    if (field.type === type && field.templateOptions?.label === label) {
      return field;
    } else if (field.fieldGroup) {
      const found = this.findFieldByTypeAndLabel(field.fieldGroup, type, label);
      if (found) return found;
    }
  }
  return null;
}

  ngOnInit(): void {

    this.fields = this.data['indJsonForm'];
      if(localStorage.getItem('authToken')){
        this.getCountryList().subscribe(cres=>{
      });
    }

    // Subscribe to form value changes
    this.form.valueChanges.subscribe(value => {
      if(this.model === null){
        this.model = value;
      }
      const businessNature = this.getValueByKey('countryOfOrigin');
      if (!businessNature || 
        (typeof businessNature === 'string' && businessNature.trim().length === 0) || 
        (typeof businessNature === 'string' && businessNature.length <= 4)) {
      this.getCountryOfOrigin(businessNature, 'add');
    }
    });
    
      this.bindFunctionsToTemplateOptions(this.fields);
      this.modalWidth = this.data['modalWidth'];
   
    let countryOfOriginAutoCompleteField = this.findFieldByKey(this.fields, 'countryOfOrigin');
    if (countryOfOriginAutoCompleteField) {
      countryOfOriginAutoCompleteField.formControl?.setValue(this.model['countryOfOrigin'].label, { emitEvent: false });
      this.isCountryOriginData = true;
    }

    const sectionField = this.findFieldByTypeAndLabel(this.fields, 'section', 'Add Individual');
    if (sectionField) {
      sectionField.templateOptions.label = 'Add Individual';
    }

    if(localStorage.getItem('authToken')){
      this.getCountryList().subscribe(cres=>{
    });
  
  }
  this.bindFunctionsToTemplateOptions(this.fields);
  this.modalWidth = this.data['modalWidth'];

  }

  onInMailingCountryChange(event: any) {
    this.indMailingZip = '';
    this.selectedMailingCountryID = event;
      const fieldsToClear = ['mailingState', 'mailingCity', 'mailingZip'];
      fieldsToClear.forEach(key => {
        const field = this.findFieldByKey(this.fields, key);
        if (field && field.formControl) {
          field.formControl.setValue(null, { emitEvent: false });
          field.formControl.markAsUntouched(); 
          field.formControl.markAsPristine(); 
        }
      });
  }
  functionMap = {
    onResidentialCountryChange: this.onResidentialCountryChange.bind(this),
    onInMailingCountryChange: this.onInMailingCountryChange.bind(this),
    getSelectedCountryOfOrigin: this.getSelectedCountryOfOrigin.bind(this),
    ValidateResidentialZipCode: (field: FormlyFieldConfig, event: FocusEvent) => this.ValidateResidentialZipCode(field, event),
    ValidateMailingZipCode: (field: FormlyFieldConfig, event: FocusEvent) => this.ValidateMailingZipCode(field, event),
  };
  
  bindFunctionsToTemplateOptions(fields: FormlyFieldConfig[]) {
    fields.forEach(field => {
      if (field.fieldGroup) {
        this.bindFunctionsToTemplateOptions(field.fieldGroup);
      } else if (field.templateOptions && field.templateOptions.onClick) {
        const functionName = field.templateOptions.onClick;
        if (this.functionMap[functionName]) {
          field.templateOptions.onClick = this.functionMap[functionName];
        }
      }else if (field.templateOptions && field.templateOptions.onOptionSelected) {
          const functionName = field.templateOptions.onOptionSelected;
          if (this.functionMap[functionName]) {
            field.templateOptions.onOptionSelected = this.functionMap[functionName];
          }
      }
      // Bind blur event correctly
      if (field.templateOptions?.blurEvent) {
        const functionName = field.templateOptions.blurEvent;
        if (this.functionMap[functionName]) {
          field.templateOptions.blur = (field: FormlyFieldConfig, event: FocusEvent) => {
            if(functionName==='ValidateResidentialZipCode'){
              this.functionMap[functionName](field?.formControl?.value, true);
              
            }else if(functionName==='ValidateMailingZipCode'){
              this.functionMap[functionName](field?.formControl?.value, true);
              
            }
          }
        }
      }
     
  
       // Recursively bind functions for nested field groups
       if (field.fieldGroup) {
        this.bindFunctionsToTemplateOptions(field.fieldGroup);
      }
      if (field.templateOptions?.changeFunction) {
        const functionName = field.templateOptions.changeFunction;
        if (this.functionMap[functionName]) {
          field.templateOptions.selectionChange = (field: FormlyFieldConfig,event:Event) => {
          if(functionName==='onResidentialCountryChange'){
          if(field?.formControl?.value){
          this.functionMap[functionName](field?.formControl?.value);
          }
        }  else  if(functionName==='onInMailingCountryChange'){
          if(field?.formControl?.value){
          this.functionMap[functionName](field?.formControl?.value);
          }
        }
      }
    }
  }
    });
  }
  
  findFieldByKey(fields: FormlyFieldConfig[], key: string): FormlyFieldConfig | null {
    for (const field of fields) {
      if (field.key === key) {
        return field;
      }
      if (field.fieldGroup && field.fieldGroup.length) {
        const nestedField = this.findFieldByKey(field.fieldGroup, key);
        if (nestedField) {
          return nestedField;
        }
      }
    }
    return null;
  }
  
  getValueByKey(key: string, type?) {
    return this.form.get(key)?.value;
  }
  
  
  getValueByKeyEdit(key: string, type?) {
    return this.form.get(key)?.value;
  }
  
  getCountryOfOrigin(search?, type?) {
    let countryOfOriginAutoCompleteField: any
    countryOfOriginAutoCompleteField = this.findFieldByKey(this.fields, 'countryOfOrigin');
  
    if(search !=  undefined && search && search.length > 0){
        this.spinner.show();
        const apiData = {
         instance_id: localStorage.getItem('instance_id'),
          email: localStorage.getItem('email'),
          search: search
        };
        this._api.functionPOST('web/allCountriesList', apiData).subscribe((response) => {
          this.updateFieldOptions('countryOfOrigin', response['data'].map((country: { bt_country_id: any; name: any; }) => ({
            value: country.bt_country_id,
            label: country.name 
          })));
          this.spinner.hide();
        },
          err => {
          });
    }else {
      if (countryOfOriginAutoCompleteField) {
        countryOfOriginAutoCompleteField.formControl?.setValue('', { emitEvent: false });
        this.isCountryOriginData = false;
      }
    }
    }
  
   getSelectedCountryOfOrigin(data: any) {
      let countryOfOriginAutoCompleteField: any;
        countryOfOriginAutoCompleteField = this.findFieldByKey(this.fields, 'countryOfOrigin');
        this.model['countryOfOrigin'] = data.label;
      if (countryOfOriginAutoCompleteField && countryOfOriginAutoCompleteField.formControl?.value !== data.label) {
        countryOfOriginAutoCompleteField.formControl?.setValue(data.label, { emitEvent: false });
        this.isCountryOriginData = true;
        
      }
    }
  
  // get country list
  getCountryList(): Observable < boolean > {
    return new Observable(observer => {
    this.spinner.show();
    const apiData = {
     instance_id: localStorage.getItem('instance_id'),
      email: localStorage.getItem('email')
    };
    this._api.functionPOST('web/countriesList', apiData).subscribe((res) => {
      this.updateFieldOptions('residentialCountry', res['data'].map((country: { bt_country_id: any; name: any; }) => ({
        value: country.bt_country_id,
        label: country.name 
      })));
      this.updateFieldOptions('indMailingCountry', res['data'].map((country: { bt_country_id: any; name: any; }) => ({
        value: country.bt_country_id,
        label: country.name 
      })));
      observer.next(true);
      observer.complete();
      this.spinner.hide();
    },
      err => {
      });
    });
  }

    onResidentialCountryChange(event: any) {
      this.residentialZip = '';
          this.selectedResidentialCountryID = event;
          const fieldsToClear = ['residentialState', 'residentialCity', 'residentialZip'];
          fieldsToClear.forEach(key => {
            const field = this.findFieldByKey(this.fields, key);
            if (field && field.formControl) {
              field.formControl.setValue(null, { emitEvent: false });
              field.formControl.markAsUntouched(); 
              field.formControl.markAsPristine(); 
            }
          });
    }
    
    updateFieldOptions(key: string, options: any[]) {
        const field_edit = this.findFieldByKey(this.fields, key);
        if (field_edit && field_edit.templateOptions) {
          field_edit.templateOptions.options = options;
        }
    }

    ValidateResidentialZipCode(zip_code?, type?) {
      const zipCode = zip_code;
      const stateField = this.findFieldByKey(this.fields, 'residentialState');
      const cityField = this.findFieldByKey(this.fields, 'residentialCity');
      const zipCodeField = this.findFieldByKey(this.fields, 'residentialZip');

      if(zipCode && this.residentialZip !== zipCode){
        this.spinner.show();
        const apiData = {
          zipcode: zipCode,
          Country: this.selectedResidentialCountryID
        };
        this._api.functionPOST('zipcode/findZip', apiData).subscribe((response) => {
          
          if(response['success'] && response['data'].length > 0){
                if (stateField) {
                  stateField.formControl?.setValue(response['data'][0]['bt_region']['name'], { emitEvent: false });
                    this.model['residentialState'] = response['data'][0]['bt_region']['name'];
                }
                if (cityField) {
                  cityField.formControl?.setValue(response['data'][0]['city'], {emitEvent: false});
                  this.model['residentialCity'] = response['data'][0]['city'];
                }
          } else {
            this.residentialZip = '';
            this._api.openSnackBar('Invalid zipcode', 'Error');
              if (stateField) {
                stateField.formControl?.setValue('', { emitEvent: false });
              }
              if (cityField) {
                cityField.formControl?.setValue('', {emitEvent: false});
              }
              if (zipCodeField) {
                zipCodeField.formControl?.setValue('', {emitEvent: false});
              }
          }
          this.spinner.hide();
        },
          err => {
          });
        }
        if(!zipCode){
          if (stateField) {
            stateField.formControl?.setValue('', { emitEvent: false });
          }
          if (cityField) {
            cityField.formControl?.setValue('', {emitEvent: false});
          }
          if (zipCodeField) {
            zipCodeField.formControl?.setValue('', {emitEvent: false});
          }
        }
        this.residentialZip = zipCode;
    }
  
    ValidateMailingZipCode(zip_code?, type?) {
      let mailingStateField: any;
      let mailingCityField: any;
      let mailingZipCodeField: any;
      const zipCode = zip_code;
    
      mailingStateField = this.findFieldByKey(this.fields, 'mailingState');
       mailingCityField = this.findFieldByKey(this.fields, 'mailingCity');
       mailingZipCodeField = this.findFieldByKey(this.fields, 'mailingZip');

      if(zipCode && this.indMailingZip!=zipCode){
  
      
        this.spinner.show();
        const apiData = {
          zipcode: zipCode,
          Country: this.selectedMailingCountryID
        };
        this._api.functionPOST('zipcode/findZip', apiData).subscribe((response) => {
  
            if(response['data'].length > 0){
  
              if (mailingStateField) {
                mailingStateField.formControl?.setValue(response['data'][0]['bt_region']['name'], { emitEvent: false });
                
                
                  this.model['mailingState'] = response['data'][0]['bt_region']['name'];
              
              }
              if (mailingCityField) {
                mailingCityField.formControl?.setValue(response['data'][0]['city'], {emitEvent: false});
                  this.model['mailingCity'] = response['data'][0]['city'];
          
              }
  
            } else {
              this.indMailingZip = '';
              this._api.openSnackBar('Invalid zipcode', 'Error');
              if (mailingStateField) {
                mailingStateField.formControl?.setValue('', { emitEvent: false });
              }
              if (mailingCityField) {
                mailingCityField.formControl?.setValue('', {emitEvent: false});
              }
              if (mailingZipCodeField) {
                mailingZipCodeField.formControl?.setValue('', {emitEvent: false});
              }
            }
            this.spinner.hide();
          },
          err => {
          });
        }
        if(!zipCode){
          if (mailingStateField) {
            mailingStateField.formControl?.setValue('', { emitEvent: false });
          }
          if (mailingCityField) {
            mailingCityField.formControl?.setValue('', {emitEvent: false});
          }
          if (mailingZipCodeField) {
            mailingZipCodeField.formControl?.setValue('', {emitEvent: false});
          }
        }
        this.indMailingZip = zipCode;
            
    }
  

  close() {
    this.form.reset();
    this.dialogRef.close();
  }

  // Edit Ind Form
  addIndividualDetails() {
    if (this.form.valid) {
      this.dialogRef.close(this.model);
    }else{
      this._api.openSnackBar('Please complete all required fields.', 'Error');
    }
  }

}